import { SafetyCertificateOutlined } from '@ant-design/icons';
import { Tag } from 'antd';

type AllProps = {
  status?: 'accepted' | 'revoked' | null;
};

function HipaaStatusTag({ status }: AllProps) {
  if (status === 'accepted') {
    return (
      <Tag icon={<SafetyCertificateOutlined />} color="success">
        Authorized
      </Tag>
    );
  }

  return <Tag color="error">Not Authorized</Tag>;
}

export default HipaaStatusTag;
